import React from 'react';
import { Card, Col, Row, Segmented, Spin, Tag, message } from 'antd';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import HttpTool from '../../../tool/HttpTool';
import TimeHelp from '../../../tool/TimeHelp';
import DepositAmountSelect from './component/DepositAmountSelect';
import styles from './OrderManage.less';

//商品类型
const COMMODITY_TYPE = {
    //职业订单
    position: 'position',
    //企业成员席位订单
    companySeat: 'company_seat',
    //设备服务订单
    deviceService: 'device_service',
    //算力订单
    computePower: 'compute_power',
    //灵能充值
    magicDeposit: 'magicPowerDeposit',
};

//统计时间范围
const STAT_RANGE_OPTIONS = [
    { label: '昨日', value: 'yesterday' },
    { label: '近7天', value: 'week' },
    { label: '近30天', value: 'month' },
];

//用户类型
const USER_TYPE_OPTIONS = [
    { title: '全部用户', value: '' },
    { title: '个人用户', value: 'personal' },
    { title: '企业用户', value: 'enterprise' },
];

//订单状态(4类订单)
const ORDER_STATUS_OPTIONS = [
    { title: '全部状态', value: '' },
    { title: '权益中', value: 'using' },
    { title: '已完成', value: 'done' },
    { title: '已退款', value: 'refund' },
];

//订单状态(灵能充值只有已支付成功的记录)
const DEPOSIT_STATUS_OPTIONS = [
    { title: '全部状态', value: '' },
    { title: '已完成', value: 'done' },
];

//购买类型
const BUY_TYPE_OPTIONS = [
    { title: '全部类型', value: '' },
    { title: '包月', value: 'month_pay' },
    { title: '增值', value: 'package_pay' },
    { title: '按次', value: 'per_use_pay' },
];

//算力订单只有包月和增值两档
const POWER_BUY_TYPE_OPTIONS = [
    { title: '全部类型', value: '' },
    { title: '包月', value: 'month_pay' },
    { title: '增值', value: 'package_pay' },
];

const BUY_TYPE_MAP = {
    month_pay: '包月',
    package_pay: '增值',
    per_use_pay: '按次',
};

/**
 * 数字格式化，超过千位加分隔符
 */
function formatNumber(value) {
    if (value === null || value === undefined || value === '') {
        return '0';
    }
    let num = Number(value);
    if (isNaN(num)) {
        return '-';
    }
    return num.toLocaleString('zh-CN', { maximumFractionDigits: 2 });
}

/**
 * 
 * @param num  需要被格式化的数字
 * @param isString 是否加逗号
 * @param isLingNeng 是否为灵能
 * @returns number | string
 */
function getPrice(num, isString = true, isLingNeng = true) {
    if (num === undefined || num === null) {
        return '0.00';
    }

    let price = num;
    if (isLingNeng) {
        price = num / 100
    }

    if (isString) {
        return price?.toLocaleString('zh-CN');
    }
    return price;
}

/**
 * 订单列表(按商品类型区分)
 * 5种商品类型共用同一套列表逻辑，差异只在筛选项和表格列
 */
export default class OrderList extends ListPage {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            statLoading: false,
            statRange: 'month',
            statistics: null,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.getStatistics();
    }

    base_getListConfig() {
        return {
            table: {
                columns: this.getTableColumns(),
                url: APILXD.orderGetList,
                otherParam: {
                    commodityType: this.props.commodityType,
                },
            },
            search: {
                seniorSearch: this.getSeniorSearch(),
                option: {
                    //筛选项全部在高级搜索区域展示
                    openSenior: true,
                    hideInput: true,
                    hideSeniorBtn: true,
                    reg: /^[\s\S]*$/,
                    beforeSubmit: (value) => {
                        delete value.keyword;
                        return true;
                    },
                }
            },
            topExtraBox: () => {
                return this.getStatisticsView();
            },
        };
    }

    /**
     * 订单统计数据
     */
    getStatistics() {
        this.setState({ statLoading: true });
        HttpTool.post(APILXD.orderStatistics, (code, msg, json) => {
            this.setState({
                statistics: json || null,
                statLoading: false,
            });
        }, (code, msg) => {
            this.setState({ statLoading: false });
            message.warning(msg);
        }, {
            commodityType: this.props.commodityType,
        });
    }

    /**
     * 统计卡片
     */
    getStatisticsView() {
        let { statistics, statRange, statLoading } = this.state;
        let statData = (statistics && statistics[statRange]) || {};
        let totalNetMagic = statistics ? statistics.totalNetMagic : 0;

        return (
            <Row gutter={15} className={styles.statisticsBox}>
                <Col span={16}>
                    <Card
                        size={'small'}
                        className={`${styles.statisticsCard} ${styles.periodCard}`}
                        title={<span className={styles.cardLabel}>本期统计</span>}
                        extra={<Segmented
                            size={'small'}
                            value={statRange}
                            options={STAT_RANGE_OPTIONS}
                            onChange={(value) => {
                                this.setState({ statRange: value });
                            }}
                        />}
                    >
                        <Spin spinning={statLoading}>
                            <div className={styles.periodBody}>
                                <div className={styles.periodItem}>
                                    <div className={styles.cardLabel}>本期收入灵能</div>
                                    <div className={styles.cardValue}>
                                        {getPrice(statData.netMagic)}
                                        <span className={styles.cardUnit}>灵能</span>
                                    </div>
                                    <div className={styles.cardExtra}>
                                        统计范围：{statData.startTime ? TimeHelp.getYMD(statData.startTime) : '--'}
                                        &nbsp;~&nbsp;
                                        {statData.endTime ? TimeHelp.getYMD(statData.endTime) : '--'}
                                    </div>
                                </div>
                                <div className={styles.periodItem}>
                                    <div className={styles.cardLabel}>本期订单笔数</div>
                                    <div className={styles.cardValue}>
                                        {formatNumber(statData.orderCount)}
                                        <span className={styles.cardUnit}>笔</span>
                                    </div>
                                    <div className={styles.cardExtra}>
                                        有效 {formatNumber(statData.validCount)} 笔 · 笔均 {getPrice(statData.avgMagic)} 灵能（不含已退款/待支付）
                                    </div>
                                </div>
                            </div>
                        </Spin>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card
                        size={'small'}
                        className={styles.statisticsCard}
                        title={<span className={styles.cardLabel}>累计收入灵能（全部）</span>}
                    >
                        <Spin spinning={statLoading}>
                            <div className={styles.cardValue}>
                                {this.props.commodityType === COMMODITY_TYPE.magicDeposit
                                    ? formatNumber(totalNetMagic)
                                    : getPrice(totalNetMagic)
                                }
                                <span className={styles.cardUnit}>灵能</span>
                            </div>
                            <div className={styles.cardExtra}>
                                不限定时间范围
                            </div>
                        </Spin>
                    </Card>
                </Col>
            </Row>
        );
    }

    /**
     * 筛选项
     */
    getSeniorSearch() {
        let defaultOption = {
            type: 'input',
            ver: true,
            reg: /^[\S\s]{0,50}$/,
            verMessage: '最多50个字符',
            required: false,
        };
        let commodityType = this.props.commodityType;
        let isDeposit = commodityType === COMMODITY_TYPE.magicDeposit;
        let parameterArr = [];

        //订单编号
        parameterArr.push({
            ...defaultOption,
            field: 'orderId',
            name: '订单编号',
            reg: () => {
                return true;
            },
        });

        //名称(职业名称/套餐名称)与设备编号
        if (commodityType === COMMODITY_TYPE.position) {
            parameterArr.push({
                ...defaultOption,
                field: 'name',
                name: '职业名称',
                reg: () => {
                    return true;
                },
            });
        }
        if (commodityType === COMMODITY_TYPE.computePower) {
            parameterArr.push({
                ...defaultOption,
                field: 'name',
                name: '套餐名称',
                reg: () => {
                    return true;
                },
            });
        }
        if (commodityType === COMMODITY_TYPE.deviceService) {
            parameterArr.push({
                ...defaultOption,
                field: 'deviceId',
                name: '设备编号',
                reg: () => {
                    return true;
                },
            });
        }

        //用户账号
        parameterArr.push({
            ...defaultOption,
            field: 'account',
            name: '用户名或账号',
            reg: () => {
                return true;
            },
        });

        //订单状态
        parameterArr.push({
            ...defaultOption,
            field: 'orderStatus',
            name: '订单状态',
            type: 'select',
            selectType: 'value',
            reg: () => {
                return true;
            },
            option: {
                defaultValue: {
                    key: '',
                    value: '',
                },
            },
            data: (isDeposit ? DEPOSIT_STATUS_OPTIONS : ORDER_STATUS_OPTIONS).map((obj) => {
                return { ...obj };
            }),
        });

        //类型
        if (commodityType === COMMODITY_TYPE.position || commodityType === COMMODITY_TYPE.computePower) {
            parameterArr.push({
                ...defaultOption,
                field: 'buyType',
                name: '类型',
                type: 'select',
                selectType: 'value',
                reg: () => {
                    return true;
                },
                option: {
                    defaultValue: {
                        key: '',
                        value: '',
                    },
                },
                data: (commodityType === COMMODITY_TYPE.computePower ? POWER_BUY_TYPE_OPTIONS : BUY_TYPE_OPTIONS).map((obj) => {
                    return { ...obj };
                }),
            });
        }

        //灵能充值金额
        if (isDeposit) {
            parameterArr.push({
                ...defaultOption,
                field: 'depositAmount',
                name: '充值金额',
                type: 'diy',
                component: DepositAmountSelect,
                reg: () => {
                    return true;
                },
                option: {},
            });
        }

        //用户类型(灵能充值不支持该筛选项)
        if (!isDeposit) {
            parameterArr.push({
                ...defaultOption,
                field: 'userType',
                name: '用户类型',
                type: 'select',
                selectType: 'value',
                reg: () => {
                    return true;
                },
                option: {
                    defaultValue: {
                        key: '',
                        value: '',
                    },
                },
                data: USER_TYPE_OPTIONS.map((obj) => {
                    return { ...obj };
                }),
            });
        }

        return {
            colCount: 3,
            formItemLayout: {
                labelCol: { span: 6 },
                wrapperCol: { span: 18, offset: 0 },
            },
            parameterArr,
        };
    }

    getTableColumns() {
        switch (this.props.commodityType) {
            case COMMODITY_TYPE.companySeat:
                return this.getCompanySeatColumns();
            case COMMODITY_TYPE.deviceService:
                return this.getDeviceServiceColumns();
            case COMMODITY_TYPE.computePower:
                return this.getComputePowerColumns();
            case COMMODITY_TYPE.magicDeposit:
                return this.getMagicDepositColumns();
            default:
                return this.getPositionColumns();
        }
    }

    /**
     * 职业订单
     */
    getPositionColumns() {
        return [
            {
                title: '订单编号',
                dataIndex: '_id',
                key: '_id',
            },
            {
                title: '职业名称',
                dataIndex: 'commodityInfo',
                key: 'commodityName',
                render: (text) => {
                    return (text && text.commodityName) || '-';
                }
            },
            this.getCreateTimeColumn(),
            this.getBuyTypeColumn(),
            this.getPayMagicColumn('灵能金额'),
            this.getSeatCountColumn('席位数量'),
            this.getValidityColumn(),
            this.getUserColumn(),
            this.getOrderStatusColumn(),
            this.getRefundMoneyColumn(),
        ];
    }

    /**
     * 企业成员席位订单
     */
    getCompanySeatColumns() {
        return [
            {
                title: '订单编号',
                dataIndex: '_id',
                key: '_id',
            },
            this.getCreateTimeColumn(),
            {
                title: '数量',
                dataIndex: 'comboInfo',
                key: 'seatSize',
                render: (text) => {
                    let size = text && text.excessCostSize;
                    return size ? `成员席位 × ${size}` : '-';
                }
            },
            this.getPayMagicColumn('灵能金额'),
            this.getValidityColumn(),
            this.getUserColumn(),
            this.getOrderStatusColumn(),
            this.getRefundMoneyColumn(),
        ];
    }

    /**
     * 设备服务订单
     */
    getDeviceServiceColumns() {
        return [
            {
                title: '订单编号',
                dataIndex: '_id',
                key: '_id',
            },
            this.getCreateTimeColumn(),
            {
                title: '设备编号',
                dataIndex: 'commodityId',
                key: 'deviceId',
                render: (text) => {
                    return text || '-';
                }
            },
            this.getPayMagicColumn('灵能金额'),
            this.getValidityColumn(),
            this.getUserColumn(),
            this.getOrderStatusColumn(),
            this.getRefundMoneyColumn(),
        ];
    }

    /**
     * 算力订单
     */
    getComputePowerColumns() {
        return [
            {
                title: '订单编号',
                dataIndex: '_id',
                key: '_id',
            },
            {
                title: '套餐名称',
                dataIndex: 'commodityInfo',
                key: 'commodityName',
                render: (text) => {
                    return (text && text.commodityName) || '-';
                }
            },
            this.getCreateTimeColumn(),
            this.getBuyTypeColumn(),
            this.getPayMagicColumn('灵能金额'),
            this.getValidityColumn(),
            this.getUserColumn(),
            this.getOrderStatusColumn(),
            this.getRefundMoneyColumn(),
        ];
    }

    /**
     * 灵能充值
     */
    getMagicDepositColumns() {
        return [
            {
                title: '订单编号',
                dataIndex: 'outTradeNo',
                key: 'outTradeNo',
            },
            {
                title: '下单时间',
                dataIndex: 'addTime',
                key: 'addTime',
                render: (text) => {
                    return text ? TimeHelp.getYMDHM(text) : '-';
                }
            },
            {
                title: '充值金额',
                dataIndex: 'payMoney',
                key: 'payMoney',
                render: (text) => {
                    return `¥ ${formatNumber(text)}`;
                }
            },
            this.getPayMagicColumn('灵能金额', 'payMagic', true),
            {
                title: '用户名/账号',
                dataIndex: 'userName',
                key: 'userName',
                render: (text, record) => {
                    //个人版渠道固定为 ljpc，其余为企业
                    let isPersonal = !record.companyId || record.companyId === 'ljpc';
                    return (
                        <div>
                            <div>
                                <span>{text || '-'}</span>
                            </div>
                            <div>
                                <span style={{ color: '#00000066', fontSize: 12 }}>{record.userAccount || '-'}</span>
                            </div>
                        </div>
                    );
                }
            },
            this.getOrderStatusColumn(),
        ];
    }

    getCreateTimeColumn() {
        return {
            title: '下单时间',
            dataIndex: 'createTime',
            key: 'createTime',
            render: (text) => {
                return text ? TimeHelp.getYMDHM(text) : '-';
            }
        };
    }

    getBuyTypeColumn() {
        return {
            title: '类型',
            dataIndex: 'comboInfo',
            key: 'buyType',
            render: (text) => {
                let buyType = text && text.buyType;
                return BUY_TYPE_MAP[buyType] || '-';
            }
        };
    }

    getPayMagicColumn(title, dataIndex, ifOrigin = false) {
        return {
            title,
            dataIndex: dataIndex || 'payMoney',
            key: dataIndex || 'payMoney',
            render: (text) => {
                if (ifOrigin) {
                    return formatNumber(text);
                } else {
                    return getPrice(text);
                }
            }
        };
    }

    getSeatCountColumn(title) {
        return {
            title,
            dataIndex: 'comboInfo',
            key: 'excessCostSize',
            render: (text) => {
                let size = text && text.excessCostSize;
                return size || '-';
            }
        };
    }

    /**
     * 有效期：席位/月数 + 到期时间
     */
    getValidityColumn() {
        return {
            title: '有效期',
            dataIndex: 'comboInfo',
            key: 'expirationTime',
            render: (text, record) => {
                let comboInfo = text || {};
                if (comboInfo.buyType === 'per_use_pay') {
                    return '-';
                }

                let sizeText = '';
                if (comboInfo.excessCostSize) {
                    sizeText += `${comboInfo.excessCostSize}个席位-`;
                }
                if (comboInfo.monthLimit) {
                    sizeText += `${comboInfo.monthLimit}${comboInfo.monthLimitUnit || '个月'}`;
                }

                return (
                    <div>
                        <div>{sizeText || '-'}</div>
                        <div className={styles.subText}>
                            {comboInfo.expirationTime ? `${TimeHelp.getYMD(comboInfo.expirationTime)} 到期` : '长期有效'}
                        </div>
                    </div>
                );
            }
        };
    }

    getUserColumn() {
        return {
            title: '用户名/账号',
            dataIndex: 'userName',
            key: 'userName',
            render: (text, record) => {
                //个人版渠道固定为 ljpc，其余为企业
                let isPersonal = !record.companyId || record.companyId === 'ljpc';
                return (
                    <div>
                        <div>
                            <span>{text || '-'}</span>
                        </div>
                        <div>
                            <span style={{ color: '#00000066', fontSize: 12 }}>{record.userAccount || '-'}</span>
                        </div>
                        <Tag
                            color={isPersonal ? 'blue' : 'green'}
                            style={{ marginLeft: 6 }}
                        >
                            {isPersonal ? '个人' : '企业'}
                        </Tag>
                    </div>
                );
            }
        };
    }

    getOrderStatusColumn() {
        return {
            title: '订单状态',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                if (this.props.commodityType === COMMODITY_TYPE.magicDeposit) {
                    return record.status === 'success'
                        ? <Tag color={'success'}>已完成</Tag>
                        : <Tag>{record.status || '-'}</Tag>;
                }

                if (record.status === 'refund') {
                    return <Tag color={'error'}>已退款</Tag>;
                }

                let expirationTime = record.comboInfo && record.comboInfo.expirationTime;
                if (expirationTime && expirationTime <= Date.now()) {
                    return <Tag color={'success'}>已完成</Tag>;
                }

                return <Tag color={'processing'}>权益中</Tag>;
            }
        };
    }

    getRefundMoneyColumn() {
        return {
            title: '退款金额',
            dataIndex: 'refundMoney',
            key: 'refundMoney',
            render: (text) => {
                if (text === null || text === undefined) {
                    return '-';
                }
                return getPrice(text);
            }
        };
    }
}
